import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import RequireAdmin from "./components/RequireAdmin";
import RequireOverviewAccess from "./components/RequireOverviewAccess";
import AppLayout from "./components/AppLayout";
import ForceLightTheme from "./theme/ForceLightTheme";
import Login from "./views/Login";
import AuthCallback from "./views/AuthCallback";
import Landing from "./views/Landing";
import NewSuggestion from "./views/NewSuggestion";
import SuggestionDetail from "./views/SuggestionDetail";
import SuggestionPrint from "./views/SuggestionPrint";
import OverviewPrint from "./views/OverviewPrint";
import Reports from "./views/Reports";
import Admin from "./views/Admin";
import AdminCategories from "./views/AdminCategories";
import AdminCustodians from "./views/AdminCustodians";
import AdminImport from "./views/AdminImport";
import Profile from "./views/Profile";
import ChangePassword from "./views/ChangePassword";
import ViewWorkflow from "./views/ViewWorkflow";

function LegacyEssRedirect() {
  const { pathname, search, hash } = useLocation();
  const next = pathname.replace(/^\/ess/, "/suggestions") + search + hash;
  return <Navigate to={next} replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Login runs the unauthenticated paper/serif palette, which has no dark
          counterpart — see ForceLightTheme. */}
      <Route
        path="/login"
        element={
          <ForceLightTheme>
            <Login />
          </ForceLightTheme>
        }
      />
      <Route path="/auth" element={<AuthCallback />} />
      {/* Print routes always render light — see ForceLightTheme. */}
      <Route
        path="/suggestions/:id/print"
        element={
          <RequireAuth>
            <ForceLightTheme>
              <SuggestionPrint />
            </ForceLightTheme>
          </RequireAuth>
        }
      />
      <Route
        path="/overview/print"
        element={
          <RequireAuth>
            <RequireOverviewAccess>
              <ForceLightTheme>
                <OverviewPrint />
              </ForceLightTheme>
            </RequireOverviewAccess>
          </RequireAuth>
        }
      />
      <Route
        path="/new-suggestion"
        element={
          <RequireAuth>
            <AppLayout>
              <NewSuggestion />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/overview"
        element={
          <RequireAuth>
            <AppLayout>
              <RequireOverviewAccess>
                <Reports />
              </RequireOverviewAccess>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <AppLayout>
              <Profile />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/change-password"
        element={
          <RequireAuth>
            <AppLayout>
              <ChangePassword />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/view-workflow"
        element={
          <RequireAuth>
            <AppLayout>
              <ViewWorkflow />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/suggestions/*"
        element={
          <RequireAuth>
            <AppLayout>
              <Routes>
                <Route index element={<Landing />} />
                <Route
                  path="new"
                  element={<Navigate to="/new-suggestion" replace />}
                />
                <Route
                  path="new-suggestion"
                  element={<Navigate to="/new-suggestion" replace />}
                />
                <Route
                  path="overview"
                  element={<Navigate to="/overview" replace />}
                />
                <Route
                  path="reports"
                  element={<Navigate to="/overview" replace />}
                />
                <Route
                  path="admin"
                  element={
                    <RequireAdmin>
                      <Admin />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/categories"
                  element={
                    <RequireAdmin>
                      <AdminCategories />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/custodians"
                  element={
                    <RequireAdmin>
                      <AdminCustodians />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/import"
                  element={
                    <RequireAdmin>
                      <AdminImport />
                    </RequireAdmin>
                  }
                />
                <Route path=":id" element={<SuggestionDetail />} />
              </Routes>
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route path="/ess/*" element={<LegacyEssRedirect />} />
      <Route path="/" element={<Navigate to="/suggestions" replace />} />
      <Route path="*" element={<Navigate to="/suggestions" replace />} />
    </Routes>
  );
}
